import { render, staticRenderFns } from "./StudentActivityStepEdit.vue?vue&type=template&id=bcfcd2b2&scoped=true"
import script from "./StudentActivityStepEdit.vue?vue&type=script&lang=js"
export * from "./StudentActivityStepEdit.vue?vue&type=script&lang=js"
import style0 from "./StudentActivityStepEdit.vue?vue&type=style&index=0&id=bcfcd2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfcd2b2",
  null
  
)

export default component.exports